import type { ProcessingState } from "@redux/state/shared-types";
import { createCustomerInvoice, resetCreateCustomerInvoice } from "./create-customer-invoice";
import { createReducer } from "@reduxjs/toolkit";

const initialState: ProcessingState = { processing: "idle" };

export const createCustomerInvoiceReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(createCustomerInvoice.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(createCustomerInvoice.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(createCustomerInvoice.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetCreateCustomerInvoice, () => {
    return initialState;
  });
});
